module.exports = __webpack_public_path__ + "img/vision.cef1b1c6.png";